<div class="sr-only" role="status" aria-live="assertive" aria-atomic="true">{{ statusMessage }}</div>
<zbp-zbchart-report-table
  reportLabel="Benchmark Skills Average Table"
  [showProgressReportsHelp]="false"
  [leftHeaderText]="benchmarkSkillsAverageReport?.entityViewType"
  rightHeaderText="Averages"
  [zbChart]="zbChart"
  [isPrinting]="false"
/>
<div class="styled-table-footer-container">
  <div class="styled-table-footer-left">
  </div>
  <div class="styled-table-footer-right">
    @if (collectionSize > pageSize) {
      <nav class="styled-pagination">
        <ngb-pagination
          #pagination
          [pageSize]="pageSize"
          [maxSize]="maxPageCount"
          [collectionSize]="collectionSize"
          [page]="page"
          (pageChange)="onPageChange($event)"
        />
      </nav>
    }
  </div>
</div>
